import type { UseBoundStore } from 'zustand/react';
import type { StoreApi } from 'zustand/vanilla';
import { useShallow } from 'zustand/react/shallow';
function pick<T extends object, K extends readonly (keyof T)[]>(obj: T, keys: K): Pick<T, K[number]> {
  const out = {} as Pick<T, K[number]>;
  for (const k of keys) {
    out[k] = obj[k];
  }
  return out;
}
export function createPickHook<S extends object>(useStore: UseBoundStore<StoreApi<S>>) {
  return function usePick<K extends readonly (keyof S)[]>(keys: K): Pick<S, K[number]> {
    return useStore(useShallow(s => pick(s, keys)));
  };
}
export default createPickHook;